(function () {
	if (window.collectionGridCarouselLoaded) return;
	window.collectionGridCarouselLoaded = true;

	const carouselSelector = "[data-collection-carousel]";
	let carouselObserver = null;
	let resizeFrame = null;

	// Theme-editor CSS can turn a carousel into a multi-row grid at a breakpoint.
	// Swiper must not translate that grid as though its cards were one long row.
	function syncGridLayout(carousel) {
		const list = carousel.querySelector(".collection-grid__list");
		const display = list && window.getComputedStyle(list).display;
		const isGrid = display === "grid" || display === "inline-grid";

		if (isGrid) {
			if (carouselObserver) carouselObserver.unobserve(carousel);
			carousel.removeAttribute("data-eyesnug-carousel-observed");
			if (typeof carousel.collectionGridCleanup === "function") {
				carousel.collectionGridCleanup();
				carousel.collectionGridCleanup = null;
			}
			if (carousel.swiper && !carousel.swiper.destroyed) {
				carousel.swiper.destroy(true, true);
			}
			carousel.scrollLeft = 0;
			carousel.removeAttribute("aria-roledescription");
		} else if (carousel.classList.contains("collection-grid__carousel--grid")) {
			carousel.setAttribute("aria-roledescription", "carousel");
		}

		carousel.classList.toggle("collection-grid__carousel--grid", isGrid);
		return isGrid;
	}

	function addFocusHandling(carousel, swiper) {
		function handleFocusIn(event) {
			const slide = event.target.closest(".collection-grid__slide");
			if (!slide || !carousel.contains(slide)) return;

			window.requestAnimationFrame(function () {
				if (swiper.destroyed) return;

				const carouselBounds = carousel.getBoundingClientRect();
				const slideBounds = slide.getBoundingClientRect();
				const slideIndex = Array.prototype.indexOf.call(swiper.slides, slide);

				if (
					slideIndex >= 0 &&
					(slideBounds.left < carouselBounds.left ||
						slideBounds.right > carouselBounds.right)
				) {
					swiper.slideTo(slideIndex);
				}
			});
		}

		function handleKeyDown(event) {
			if (event.key !== "ArrowLeft" && event.key !== "ArrowRight") return;
			if (!carousel.contains(document.activeElement) || swiper.destroyed) return;

			const isRtl = window.getComputedStyle(carousel).direction === "rtl";
			const moveNext = event.key === "ArrowRight" ? !isRtl : isRtl;
			event.preventDefault();
			if (moveNext) {
				swiper.slideNext();
			} else {
				swiper.slidePrev();
			}
		}

		carousel.addEventListener("focusin", handleFocusIn);
		carousel.addEventListener("keydown", handleKeyDown);
		carousel.collectionGridCleanup = function () {
			carousel.removeEventListener("focusin", handleFocusIn);
			carousel.removeEventListener("keydown", handleKeyDown);
		};
	}

	function initializeCarousel(carousel) {
		if (!carousel || syncGridLayout(carousel) || carousel.swiper || typeof window.Swiper === "undefined") {
			return;
		}

		const desktopColumns = Math.max(
			1,
			Number.parseInt(carousel.dataset.desktopColumns, 10) || 3,
		);
		const slideCount = Number.parseInt(carousel.dataset.slideCount, 10) || 0;
		const mobileSlides = Math.max(
			1,
			Number.parseFloat(carousel.dataset.mobileSlides) || 1.18,
		);
		const compactMobile = mobileSlides >= 2.5;
		const mobileGap = compactMobile ? 10 : 16;
		const availableSlides = Math.max(1, Math.min(slideCount, desktopColumns));
		const desktopSlides =
			slideCount > desktopColumns ? desktopColumns + 0.15 : availableSlides;
		const reducedMotion = window.matchMedia(
			"(prefers-reduced-motion: reduce)",
		).matches;

		const swiper = new window.Swiper(carousel, {
			a11y: {
				enabled: true,
			},
			breakpoints: {
				576: {
					slidesPerView: Math.min(compactMobile ? 2.5 : 2.3, desktopSlides),
					spaceBetween: mobileGap,
				},
				990: {
					slidesPerView: Math.min(3.2, desktopSlides),
					spaceBetween: 16,
				},
				1100: {
					slidesPerView: desktopSlides,
					spaceBetween: 16,
				},
			},
			centerInsufficientSlides: true,
			grabCursor: true,
			loop: false,
			slidesPerView: Math.min(mobileSlides, desktopSlides),
			spaceBetween: mobileGap,
			speed: reducedMotion ? 0 : 450,
			watchOverflow: true,
		});

		carousel.removeAttribute("data-eyesnug-carousel-observed");
		addFocusHandling(carousel, swiper);
	}

	function ensureRuntime(carousel) {
		if (!carousel || syncGridLayout(carousel) || carousel.swiper) return;

		if (typeof window.Swiper === "function") {
			initializeCarousel(carousel);
			return;
		}

		if (window.EyesnugSwiperLoader) {
			window.EyesnugSwiperLoader.load().then(function () {
				initializeCarousel(carousel);
			});
		}
	}

	function observeCarousel(carousel) {
		if (!carousel || syncGridLayout(carousel) || carousel.swiper || carousel.hasAttribute("data-eyesnug-carousel-observed")) {
			return;
		}

		if (!("IntersectionObserver" in window)) {
			ensureRuntime(carousel);
			return;
		}

		if (!carouselObserver) {
			carouselObserver = new IntersectionObserver(function (entries) {
				entries.forEach(function (entry) {
					if (!entry.isIntersecting) return;
					carouselObserver.unobserve(entry.target);
					entry.target.removeAttribute("data-eyesnug-carousel-observed");
					ensureRuntime(entry.target);
				});
			}, { rootMargin: "300px 0px", threshold: 0.01 });
		}

		carousel.setAttribute("data-eyesnug-carousel-observed", "true");
		carouselObserver.observe(carousel);
	}

	function observeCarousels(scope) {
		const root = scope && scope.querySelectorAll ? scope : document;
		root.querySelectorAll(carouselSelector).forEach(observeCarousel);
	}

	function initializeFromIntent(event) {
		const target = event.target;
		if (!(target instanceof Element)) return;
		const carousel = target.closest(carouselSelector);
		if (!carousel) return;

		if (carouselObserver) carouselObserver.unobserve(carousel);
		carousel.removeAttribute("data-eyesnug-carousel-observed");
		ensureRuntime(carousel);
	}

	document.addEventListener("pointerdown", initializeFromIntent, { passive: true });
	document.addEventListener("touchstart", initializeFromIntent, { passive: true });
	document.addEventListener("focusin", initializeFromIntent);

	window.addEventListener("resize", function () {
		if (resizeFrame !== null) return;
		resizeFrame = window.requestAnimationFrame(function () {
			resizeFrame = null;
			observeCarousels(document);
		});
	}, { passive: true });

	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", function () {
			observeCarousels(document);
		}, { once: true });
	} else {
		observeCarousels(document);
	}

	document.addEventListener("shopify:section:load", function (event) {
		observeCarousels(event.target);
	});

	document.addEventListener("shopify:section:unload", function (event) {
		event.target.querySelectorAll(carouselSelector).forEach(function (carousel) {
			if (carouselObserver) carouselObserver.unobserve(carousel);
			if (typeof carousel.collectionGridCleanup === "function") {
				carousel.collectionGridCleanup();
			}
			if (carousel.swiper && !carousel.swiper.destroyed) {
				carousel.swiper.destroy(true, true);
			}
		});
	});
})();
